<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/03/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/03/profile_sp.png')"
    profileAlt="03 RISA TAKAHASHI"
    answer01="大学では化学工学を専攻。触媒の構造をデザインし、構造とアプリケーション性能の相関性を明らかにする研究に取り組んでいました。触媒の構造とその性能を紐づけるため、実験と解析を繰り返す日々でした。クレハでは触媒はつくっていませんが、化学プラントなどの現場での生産効率や収率をイメージしながら研究をしていたので、そういう意味では現在の仕事内容にも繋がっているのかなと思います。"
    answer02="多様な製品を扱えて、かつスケールの大きな事業に携われることから、素材メーカーに絞って就職活動をしていました。クレハに興味を持ったのも、幅広い製品を展開しているからだったのですが、最終的な決め手になったのは人でした。技術面談で自分の研究内容を社員の方々にプレゼンしたときに、学会発表の時くらい熱心に聞いてくださり、質問やアドバイスをいただきました。この方々と一緒に働くことができたら充実した会社生活になるだろうと思い、入社を決めました。"
    answer03="新規農薬の合理的な製造プロセスの開発と設計が主な業務内容です。具体的には、ラボ、パイロット、実機と段階を踏んでスケールアップする際に発生しうる問題に対して、計算や実験に基づいた解決方法の提案や設備の改善などを行なっています。反応の収率改善はもちろん、原料コスト低減や廃棄物量の削減などの検討が必要です。さらに、安全性や操作性など、多角的な視点で考えなければいけない難しさがあります。でも、自分自身の判断がプラントの安全性向上やコスト削減に直結するので、やりがいも大きいです。"
    answer04="まずは、現在自分が携わっている製品を世の中に送り出すこと。そのために、量産化に向けてクリアすべき課題点について各方面の方々と議論を重ね、プロセス開発からプラントの設計・操業まで幅広く携わることができればと考えています。個人的なスキルとしては、定量的な議論ができるケミカルエンジニアを目指しています。部署には経験豊富な先輩がたくさんいるので、私も早く追いつけるように頑張りたいです。"
    answer05="アットホームなところ。仕事以外のことでも、困っていると話を聞いてくれるやさしい人が多いですし、年齢や立場に関係なく意見を言いやすい環境だと思います。それと、いわき事業所のまわりは自然が豊かで、のんびりした空気感に癒されます。たまに事業所の中をうさぎが歩いていたりすることもあるようです（笑）。近くには新鮮な魚を安く買えてその場で食べられる公設市場があり、休日はそこでグルメな時間を過ごしています。"
    answer06="お風呂やサウナでゆっくり過ごすのが好きなので、スーパー銭湯や温泉施設によく行きます。いわきには湯本温泉という温泉街やお風呂の種類が豊富な健康センターがいくつかあるので、週末には色々な施設を巡っています。休日にサウナやお風呂で疲労を回復して、平日はより一層仕事に集中することができています。また、仲の良い同期や同僚とホームパーティーをすることもあります。楽しくお話をしながら、ホットプレートを囲んで鉄板料理を食べたり、とても良いリフレッシュになっています。"
    :imageCut01="require('../../assets/img/lab/staff/03/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/03/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/03/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/03/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/03/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/03/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
